import { InterInstance } from '@api/config';

export const getToken = async () => {
  try {
    const {
      data: { data },
    } = await InterInstance({
      method: 'post',
      url: `/authorization/token`,
      data: {
        client_id: 'z0PKRSO3cV7b6yj2blDt3n3UFPaErjN8',
        client_secret:
          '074mcPc01xgTd-K5Iq70IsygkhnyUaK4DNIYGVFsiwFX6kgSHONsQcQwi8S8D3ZO',
      },
    });
    return data.access_token;
  } catch (e) {
    return e;
  }
};
